const state = {
  selection: 'petition',
  details: {
    firstName: null,
    lastName: null,
    email: null,
    postcode: null,
    phoneNumber: null,
    agreesDisplayName: true
  },
  currentStep: 0
};

const getters = {
  selection: (state) => state.selection,
  isPetition: (state) => state.selection === 'petition',
  isDonation: (state) => state.selection === 'donation',
};

const mutations = {
  updateSelection(state, selection) {
    if (state.selection != selection) {
      state.selection = selection;
    }
  },
  updateLeafRelief(state, { field, value }) {
    if (state[field] != value) {
      state[field] = value;
    }
  },
  updateLeafReliefPaymentType(state, type) {
    state.donation.paymentType = type;
  },
  resetLeafRelief(state) {
    state.details = {
      firstName: null,
      lastName: null,
      email: null,
      postcode: null,
      phoneNumber: null,
      agreesDisplayName: true
    };
  }
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/leaf-relief.js